export default "__VITE_ASSET__B9OzH_3y__"